import { apiClient, Auth, HttpError } from '@/shared/api'
import { getCookie } from '@/shared/lib/server'

import { TRoomResponse } from './schema'

export const getRoom = async ({ roomId }: { roomId: number }) => {
  const uuid = await getCookie('uuid')

  try {
    const { data } = await apiClient.get<TRoomResponse>({
      endpoint: `/rooms/${roomId}`,
      queryParams: { uuid },
      auth: Auth.OPTIONAL,
    })

    return {
      response: data,
      error: null,
    }
  } catch (error) {
    if (error instanceof HttpError) {
      return {
        response: null,
        error: error.code,
      }
    }

    return {
      response: null,
      error,
    }
  }
}
